import { c as _c } from "react/compiler-runtime";
import { gql, useMutation } from '@material-bank/graphql-client';
import type { ItemStatus } from '@material-bank/mb3-projects-client/graphql';
type UpdateSampledItemStatusData = {
  updateSampledItemStatus: {
    id: string;
    status: ItemStatus;
  };
};
export type UpdateSampledItemStatusVars = {
  itemID: string;
  status: ItemStatus;
};
const updateSampledItemStatusMutation = gql`
  mutation UpdateSampledItemStatus($itemID: UUID!, $status: ItemStatus!) {
    updateSampledItemStatus(itemID: $itemID, status: $status) {
      id
      status
    }
  }
`;
export function useUpdateSampledItemStatusMutation() {
  const $ = _c(5);
  const [mutate, t0] = useMutation(updateSampledItemStatusMutation);
  const {
    data,
    error,
    loading
  } = t0;
  const t1 = data?.updateSampledItemStatus;
  let t2;
  if ($[0] !== error || $[1] !== loading || $[2] !== mutate || $[3] !== t1) {
    t2 = {
      updateStatus: mutate,
      data: t1,
      error,
      loading
    };
    $[0] = error;
    $[1] = loading;
    $[2] = mutate;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}